module.exports = __webpack_public_path__ + "static/media/IMG_2263.479e69b2.jpg";